export const copyToken = (element : HTMLElement, ch: any) => {

    //This code copies the text to the clipboard
    if (element) {
        if (!navigator.clipboard) {
            let textArea = document.createElement("textarea");
            textArea.value = ch.token.value;
            document.getElementsByTagName("body")[0].appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.getElementsByTagName("body")[0].removeChild(textArea);
            ch.token.copied = true;
            setTimeout(() => {
                ch.token.copied = false;
            }, 2000);
        } else {
            navigator.clipboard
                .writeText(ch.token.value)
                .then(() => {
                    ch.token.copied = true;

                    setTimeout(() => {
                        ch.token.copied = false;
                    }, 2000);
                })
                .catch(() => {
                    ch.token.copied = false;
                });
        }

       
    }
};